import { render, staticRenderFns } from "./ResetPasswordValidate.vue?vue&type=template&id=68d4defb&scoped=true"
import script from "./ResetPasswordValidate.vue?vue&type=script&lang=js"
export * from "./ResetPasswordValidate.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordValidate.vue?vue&type=style&index=0&id=68d4defb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d4defb",
  null
  
)

export default component.exports